<script>
import BaseListing from '../../../../share/ListingWithEditMode'

export default {
  mixins: [
    BaseListing
  ],
  data () {
    return {
      service: this.$route.meta.acl.service,
      headerTitle: { title: 'Widoczność pól', description: 'Lista' },
      editModeUrlName: '',
      gridDataSource: null,
      gridName: 'grid_appraisal_task_field_visibility',
      editEventName: ''
    }
  },
  computed: {
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: () => { return '' }
        },
        { id: 1, data: 'field', title: 'Pole' },
        { id: 2, data: 'fieldGroup', title: 'Grupa' },
        { id: 3, data: 'state', title: 'Stan' },
        { id: 4, data: 'role', title: 'Rola' },
        { id: 5, data: 'visibility', title: 'Poziom dostępu' }
      ]
    }
  },
  created () {
    this.getInitEditModeUrlName()
    this.getInitEditEventName()
    this.getInitGridDataSource()
  },
  methods: {
    getInitEditModeUrlName () {
      this.editModeUrlName = `${this.service}_appraisal_field_access_edit`
    },
    getInitEditEventName () {
      this.editEventName = `${this.service}:appraisal:fieldVisibilityEdit`
    },
    getInitGridDataSource () {
      this.gridDataSource = { service: this.service, url: '/schemas/appraisal/field-visibility' }
    }
  }
}
</script>
